import objectives from "./objectives"
import players from "./players"

export default {
    objectives,
    players,
}